module.exports = __webpack_public_path__ + "img/ecuador.448e8621.png";